<template>
  <div class="container">
    <div height="60px" class="header">
      <page-header></page-header>
    </div>
    <div class="main" :class="{'set-flex': setFlex}" ref="main">
      <div class="seller-register">
        <!-- bind phone -->
        <div class="bind-phone" v-if="isBindPhone">
           <!-- 微信信息 -->
           <div class="top">
             <img :class="{ girl: userInfo.sex === 2 }" class="boy" :src="userInfo.avatar" alt="">
             <span>{{ userInfo.nickname }}</span>
           </div>
           <!-- 填写注册信息 -->
           <div class="bottom">
             <base-input v-model="form.realname" placeholder="真实姓名" :isLimitLength="true" :limitLength="15" :autofocus="true"/>
             <base-input 
              class="phone" 
              type="text" 
              v-model="form.phone" 
              placeholder="手机号码"
              :isLimitLength="true" 
              :limitLength="11" 
              :hasError="showPhoneError" 
              :errorMsg="phoneErrorMsg" 
              @ipt-focus="phoneFocus"
              @input="phoneInput"
              @ipt-blur="phoneBlur"
            />
             <div class="valide">
              <base-input class="ipt" type="text" :isNumber="true" v-model="form.verifyCode" placeholder="验证码" :hasError="showVerifyCodeError" errorMsg="验证码不正确" :isLimitLength="true" :limitLength="4" @ipt-focus="showVerifyCodeError = false">
                <button :class="{'not-click': isGettingCode}" @click="getVertifyCode">{{ text }}</button>
              </base-input>
             </div>
             <!-- 确认与取消 -->
            <div class="btn-box">
              <button class="confirm" :class="{disabled: !canIRegisterPhone}" :disabled="!canIRegisterPhone" @click="register">确认注册</button>
              <el-button class="logout" type="text" @click="logout">退出登录</el-button>
            </div>
           </div>
        </div>
        <!-- bind wx -->
        <div class="bind-wx" v-else>
          <div class="phone">
            <i>您好，</i><span class="green">{{ userInfo.phone }}</span>
          </div>
          <ul class="wrap">
            <li class="one">
              <p>
                <img src="~@/assets/images/one_step.svg" alt=""> 请输入您的真实姓名
              </p>
              <base-input width="428px" v-model="wxForm.realname" placeholder="真实姓名" :isLimitLength="true" :limitLength="15" :autofocus="true"/>
            </li>
            <li class="two">
              <p>
                <img src="~@/assets/images/two_step.svg" alt=""> 关注公众号店铺动态实时通知，帮您赚钱的经营利器
              </p>
              <div class="canvas-wrap">
                <canvas ref="canvas" width="150" height="150"></canvas>
                <!-- 二维码失效 -->
                <div class="qr-expire" v-if="isQrCodeExpired">
                  <span>二维码已失效</span>
                  <button class="refresh" @click="ReFreshHandleBindWx">刷新</button>
                  <div class="mask"/>
                </div>
                <!-- 关注成功 -->
                <div class="follow-success" v-if="isFollowSuccess">
                  <img src="~@/assets/images/complete.svg" alt="">
                  <span>关注成功</span>
                  <div class="mask"/>
                </div>
              </div>
            </li>
          </ul>
          <div class="btn-box">
            <button class="confirm" :class="{disabled: !canIRegisterWx}" :disabled="!canIRegisterWx" @click="registerByWxBind">确认注册</button>
            <el-button class="logout" type="text" @click="logout">退出登录</el-button>
          </div>
        </div>
    </div>
    </div>
    <!-- footer -->
    <footer>注册有疑问？拨打森果云官方热线 400-027-0135</footer>
    <bind ref="bind" @bindwx-success="handleBindWxSuccess" @qrcode-expired="isQrCodeExpired = true" @qrcode-not-expired="isQrCodeExpired = false"/>
    <ypsdk ref="ypsdk"/>
  </div>
</template>

<script>
import BTime from 'best-calendar';
import bind from '@/components/bind/bind';
import PageHeader from "@/components/header/header";
// sdk
import ypsdk from '@/components/ypsdk/ypsdk';

export default {
  data() {
    return {
      text: '获取验证码',
      form: {
        realname: '',
        phone: '',
        verifyCode: ''
      },
      userInfo: {},
      setFlex: true,
      showVerifyCodeError: false,
      showPhoneError: false,
      phoneErrorMsg: '',
      isGettingCode: false,
      isBindPhone: true,
      /** ------ 上面的是绑定手机的状态，下面是绑定微信的状态 ------ */
      wxForm: {
        realname: ''
      },
      isQrCodeExpired: false,
      isFollowSuccess: false
    };
  },
  computed: {
    canIRegisterPhone() {
      let canIUse = true;
      Object.values(this.form).forEach(el => {
        if (el === '') {
          canIUse = false;
        }
      });
      return canIUse && this.testPhone();
    },

    canIRegisterWx() {
      let canIUse = true;
      Object.values(this.wxForm).forEach(el => {
        if (el === '') {
          canIUse = false;
        }
      });
      return canIUse && this.isFollowSuccess;
    }
  },
  created() {
    this.phoneReg = /^1[3456789]\d{9}$/;
    this.firstPicValid = true;
    this.isBindPhone = this.$route.query.type === 'bind_phone';
    this.getUserInfo();
    if (!this.isBindPhone) {
      // 判断是否携带参数oa="new_ls" 关注零售端微信公众号
      if(this.$route.query.oa === 'new_ls') {
        this.handleBindWx('oa_lingshou')
      } else {
        this.handleBindWx('oa_pifa')
      }
      
    }
  },
  mounted() {
    const main = this.$refs.main;
    if (main) {
      const offset = main.getBoundingClientRect();
      if (offset.height <= 660) {
        this.setFlex = false;
      }
    }
  },
  methods: {
    getVertifyCode() {
      if (!this.phoneReg.test(this.form.phone)) {
        return this.showPhoneError = true;
      }
      this.vertifyCode();
    },

    testPhone() {
      if (this.form.phone.length !== 11) return false
      if (this.form.phone[0] && this.form.phone[0] != 1) return false
      if (this.form.phone[1] && this.form.phone[1] < 3) return false
      if (!this.form.phone.split('').every(item => Number(item) === Number(item))) return false
      return true
    },

    phoneFocus() {
      this.showPhoneError = false
      this.phoneErrorMsg = ''
    },

    phoneInput() {
      // this.inputLimitNormal(this.form, 'phone')  // 去除空格
      if (this.form.phone[0] && this.form.phone[0] != 1) {
        this.showPhoneError = true
        this.phoneErrorMsg = '请输入正确的手机号'
        return
      }
      if (this.form.phone[1] && this.form.phone[1] < 3) {
        this.showPhoneError = true
        this.phoneErrorMsg = '请输入正确的手机号'
        return
      }
      if (!this.form.phone.split('').every(item => Number(item) === Number(item))) {  // 存在非数字字符
        this.showPhoneError = true
        this.phoneErrorMsg = '请输入正确的手机号'
        return
      }
      this.showPhoneError = false
      this.phoneErrorMsg = ''
    },

    phoneBlur() {
      if (this.form.phone[0] && this.form.phone[0] != 1) {
        this.showPhoneError = true
        this.phoneErrorMsg = '请输入正确的手机号'
        return
      }
      if (this.form.phone[1] && this.form.phone[1] < 3) {
        this.showPhoneError = true
        this.phoneErrorMsg = '请输入正确的手机号'
        return
      }
      if (!this.form.phone.split('').every(item => Number(item) === Number(item))) {  // 存在非数字字符
        this.showPhoneError = true
        this.phoneErrorMsg = '请输入正确的手机号'
        return
      }
      if (this.form.phone.length !== 11 && this.form.phone.length !== 0) {
        this.showPhoneError = true
        this.phoneErrorMsg = '请输入11位手机号'
      } else {
        this.showPhoneError = false
        this.phoneErrorMsg = ''
      }
    },

    vertifyCode(flag) {
      if (this.isGettingCode) return;
      const params = {
        action: 'bind',
        phone: this.form.phone
      }
      if (flag) {
        // 图片验证
        params.captcha_token = this.token;
        params.captcha_authenticate = this.authenticate;
      }
      this.isGettingCode = true;  // 正在获取验证码
      this.countDown = new BTime.CountDown(60000, 0);
      this.countDown.on('timing', time => {
        this.text = `重新发送(${time.second}s)`;
      });
      this.countDown.on('timend', () => {
        this.isGettingCode = false;
        this.text = '获取验证码';
      });
      // 获取验证码
      this.$fetch.post({
        url: '/captcha',
        params
      }).then((data) => {
        if (data.need_captcha && this.firstPicValid) {
          // 需要图片验证
          this.firstPicValid = false;
          this.ypValid();
        }else {
          // 直接获取验证码
          this.firstPicValid = true;
          console.log('验证码：', data);
        }
      }, e => {
        if (!e.success && e.error_text.includes('图形验证') && this.firstPicValid) {
          this.firstPicValid = false;
          return this.ypValid();
        }
        this.firstPicValid = true;
        this.openMessage(0, e.error_text || '获取验证码失败');
        this.countDown && this.countDown.stop(true);
      })
    },

    ypValid() {
      this.countDown && this.countDown.stop(true);
      this.$nextTick(() => {
        this.$refs.ypsdk.ready()
         .then(({ token, authenticate }) => {
          this.token = token;
          this.authenticate = authenticate;
          this.vertifyCode(true);
        });
      })
    },

    register() {
      if (this.phoneLock) return;
      // 注册
      if (!this.phoneReg.test(this.form.phone)) {
        return this.showPhoneError = true;
      }
      const bind = this.$refs.bind;
      if (bind) {
        this.phoneLock = true
        bind.open({
          bindType: 'phone',
          phone: this.form.phone,
          code: this.form.verifyCode,
          realname: this.form.realname
        }).then(flag => {
          if (flag) {
            this.openMessage(1, '登录成功');
            this.goToUrl();
          } else {
            this.phoneLock = false
          }
        }).catch(e => {
          if (e.error_text.includes('验证')) {
            this.showVerifyCodeError = true;
          } else {
            this.openMessage(0, e.error_text || '登录失败');
          }
          this.phoneLock = false
        }).finally(() => {
          this.countDown && this.countDown.stop(true)
        });
      }
    },

    logout() {
      if (this.logoutLock) return;
      this.logoutLock = true
      // 退出登录
      this.$fetch.post({
        url: '/login?method=logout'
      }).then(data => {
        if (data.success) {
          this.openMessage(1, '登出成功')
          if (this.$route.query.oa === 'new_ls') {
             this.$router.replace({
              path: '/login',
              query: {
                oa: 'new_ls'
              }
            })
          } else {
            this.$router.replace({
              path: '/login'
            })
          }
        }
      }, e => {
        this.openMessage(0, e.error_text || '登出失败')
        this.logoutLock = false
      })
    },

    getUserInfo() {
      this.$fetch.get({
        url: '/user',
      }).then(data => {
        if (data.success) {
          this.userInfo = data.user || {};
        }
      }, e => this.openMessage(0, e.error_text || '获取用户信息失败'));
    },

    /** 以下绑定微信的的方法 */
    registerByWxBind() {
      if (this.wxLock) return;
      this.wxLock = true
      this.$fetch.put({
        url: "/user?method=update_realname&realname=" + this.wxForm.realname
      }).then(data => {
        if (data.success) {
          this.goToUrl();
        }
      }, e => {
        this.openMessage(0, e.error_text || "检测微信绑定错误")
        this.wxLock = false
      })
    },

    handleBindWx(type) {
      this.$nextTick(() => {
        this.$refs.bind.open({
          el: this.$refs.canvas,
          bindType: 'wx',
          oa: type, // new_ls 表示新零售用户， pf 表非新零售用户
        })
      })
    },

    ReFreshHandleBindWx() {
      if (this.$route.query.oa === 'new_ls') {
        this.handleBindWx('oa_lingshou')
      } else {
        this.handleBindWx('oa_pifa')
      }
    },

    handleBindWxSuccess(id) {
      this.scene_id = id;
      this.isFollowSuccess = true;
      this.isQrCodeExpired = false;
    }
  },

  components: {
    bind,
    ypsdk,
    PageHeader
  }
};
</script>

<style lang="scss" scoped>
.btn-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 67px;

  .confirm {
    padding: 10px 122px;
    background: #08A681;
    box-shadow: 0 2px 3px 0 rgba(10,178,133,0.40);
    border-radius: 5px;
    font-size: 14px;
    font-weight: bolder;
    color: #FFFFFF;

    &.disabled {
      box-shadow: none;
      background: #dcdcdc;
    }
  }

  .logout {
    padding-top: 16px;
    font-size: 14px;
    color: #EE5B5B;
  }
}

.container {
  display: flex;
  flex-direction: column;
}

.seller-register {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1080px;
  height: 660px;
  margin: 0 auto;
  padding: 10px 0;
  box-sizing: border-box;
  background: #fff;

  .bind-phone {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 428px;

    .top {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 40px;

      img {
        width: 60px;
        height: 60px;
        margin-bottom: 16px;
        border-radius: 50%;
      }

      span {
        font-size: 16px;
        font-weight: bolder;
        color: #333;
      }
    }

    .bottom {

      .phone {
        margin: 18px 0;
      }

      .valide {
        display: flex;
        align-items: center;

        .ipt {
          flex: 1;
        }

        button {
          flex: none;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100px;
          height: 46px;
          background: #FFFFFF;
          border: 1px solid #08A681;
          border-radius: 0 4px 4px 0;
          font-size: 12px;
          font-weight: bolder;
          color: #08A681;

          &.not-click {
            border: 1px solid rgba(8,166,129,0.50);
            color: rgba(8,166,129,0.50);
          }
        }

        /deep/ .ipt .base-input {
          border-radius: 4px 0 0 4px;
          border-right: none;
        }
      }
    }
  }
}

.green {
  color: #009688;
}

.main {
  flex: 0 0 660px;
  overflow: auto;
  margin: 10px auto;
  box-shadow: 0 4px 10px 0 rgba(0,0,0,0.10);
  border-radius: 8px;

  &.set-flex {
    display: flex;
    align-items: center;
  }
}

.bind-wx {
  color: #333;

  .phone {
    font-size: 20px;
    font-weight: 500;
    text-align: center;
  }

  .wrap {

    > li > p {
      margin: 30px 0;
      font-weight: bolder;

      img {
        width: 40px;
        height: 40px;
      }
    }

    .canvas-wrap {
      position: relative;
      text-align: center;

      canvas {
        background: rgb(236, 241, 239);
        width: 164px;
        height: 164px;
      }

      .qr-expire,
      .follow-success {
        position: absolute;
        left: 50%;
        top: 0;
        transform: translateX(-50%);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 164px;
        height: 164px;
        color: #fff;

        span {
          font-weight: 500;
        }

        .refresh {
          margin-top: 12px;
          padding: 7px 17px;
          background: #08A681;
          border-radius: 4px;
          color: #fff;
        }

        img {
          width: 30px;
          height: 30px;
          margin-bottom: 12px;
        }

        .mask {
          position: absolute;
          left: 0;
          top: 0;
          width: 164px;
          height: 164px;
          background: rgba(0,0,0,0.50);
          z-index: -1;
        }
      }
    }
  }

  .btn-box {
    margin-top: 32px;
  }
}

footer {
  height: 60px;
  line-height: 60px;
  font-size: 14px;
  color: #666;
  text-align: center;
}
</style>
